const faqQuestions = [
    {
        categoryName: 'ZAWODY',
        questions: [
            {
                pytanie: '1. Kiedy należy przyjść na zawody?',
                odpowiedz:
                    'Na zawody należy stawić się podczas trwania czasu rejestracji pierwszego dnia. Jeśli ktoś jest pierwszy raz na zawodach powininen przyjść na początek rejestracji, aby zdążyć się zarejestrować przed szkoleniem dla nowicjuszy.',
            },
            {
                pytanie: '2. Mogę przyjechać dopiero na jeden dzień, czy tak można?',
                odpowiedz:
                    'Można przyjechać tylko na jeden dzień, ale trzeba pamiętać, że wtedy bierze się udział tylko i wyłącznie w konkurencjach, które zaczynają się (mają pierwszą rundę) danego dnia. Konkurencji, na których się nie stawiło podczas swojej grupy pierwszej rundy nie można układać. Dodatkowo jeśli ktoś jest nowicjuszem to nie należy opuszczać szkolenia dla nowicjuszy, ponieważ dzięki ukończonemu szkoleniu dla nowicjuszy delegat może przyznać ulgę nowicjusza i odejść poniekąd od zasad obowiązujących dla wszystkich. Po szkoleniu nowicjusze dostają podpis delegata o ukończonym szkoleniu i jest to podstawą do np. przyznania dodatkowego ułożenia zamiast dyskwalifikacji próby.',
            },
            {
                pytanie: '3. Czy trzeba mieć swoje kostki?',
                odpowiedz:
                    'Tak - na zawodach układa się wyłącznie na swoich kostkach. Organizator nie zapewnia kostek nawet do pożyczenia.',
            },
            {
                pytanie: '4. Czy mogę sędziować na zawodach?',
                odpowiedz:
                    'Sędzią może zostać każdy chętny uczestnik zawodów lub nawet i osoba towarzysząca, jeśli przejdzie szkolenie delegata lub uzyska jego pozwolenie.',
            },
            {
                pytanie: '5. Czy trzeba sędziować lub mieszać?',
                odpowiedz:
                    'Mieszaczem może zostać każdy chętny uczestnik zawodów, jeśli potrafi to robić. Mieszanie jest również obowiązkowe dla zawodników, którzy posiadają już WCA ID jeśli mają takie zadanie przydzielone w swoim scenariuszu.',
            },
            {
                pytanie: '6. Czy mogę startować tylko w jednej konkurencji?',
                odpowiedz: 'Tak - nie trzeba startować we wszystkich konkurencjach.',
            },
            {
                pytanie: '7. Czy w jakiś sposób mogę obniżyć kwotę wpisowego?',
                odpowiedz:
                    'Kwota wpisowego jest stała i dla każdego taka sama, zatem nie można obniżyć kwoty wpisowego.',
            },
            {
                pytanie: '8. Kto jest delegatem na zawodach?',
                odpowiedz:
                    'Osoby pełniące rolę delegata na danych zawodach są wyszczególnieni w zakładce INFORMACJE danych zawodów.',
            },
            {
                pytanie: '9. Czy będzie można przenocować na miejscu?',
                odpowiedz:
                    'Jeśli jest dostępny nocleg na miejscu, jest on wyszczególniony w zakładce INFORMACJE DODATKOWE lub w osobnej zakładce NOCLEGI na stronie danych zawodów.',
            },
            {
                pytanie: '10. Co wchodzi w cenę wpisowego?',
                odpowiedz:
                    'Co zawiera cena wpisowego jest zawsze wyszczególnione w zakładce informacje dodatkowe na danej stronie zawodów.',
            },
            {
                pytanie: '11. Czy można się zarejestrować na miejscu?',
                odpowiedz:
                    'Domyślnie rejestracja na miejscu nie jest możliwa. Jeśli jest inaczej, stosowna informacja zawiera się w zakładce INFORMACJE danych zawodów.',
            },
            {
                pytanie:
                    '12. Czy można na miejscu lub po czasie końca rejestracji dopisać się na konkurencję?',
                odpowiedz:
                    'Ostateczny termin zmiany konkurencji jest wyszczególniony na stronie w zakładce INFORMACJE. Jeśli jest możliwość zmiany konkurencji na miejscu zawodów to również w tej zakładce będzie taka informacja. W przypadku braku takiej informacji (częstszy przypadek), na miejscu nie ma możliwości zmiany konkurencji.',
            },
            {
                pytanie: '13. Jak mogę zrezygnować z konkurencji podczas zawodów?',
                odpowiedz: 'Należy zgłosić chęć rezygnacji delegatowi zawodów lub konferansjerowi.',
            },
            {
                pytanie: '14. Kiedy warto wybrać się na zawody?',
                odpowiedz:
                    'Na zawody zawsze warto pojechać. Na pierwszych zawodach nie liczą się wyniki, a poznanie się z innymi pasjonatami kostki Rubika :)',
            },
            {
                pytanie: '15. Osiągam takie i takie wyniki - czy warto pojechać na zawody?',
                odpowiedz:
                    'Na zawody zawsze warto pojechać. Na pierwszych zawodach nie liczą się wyniki, a poznanie się z innymi pasjonatami kostki Rubika :)',
            },
            {
                pytanie: '16. Czy dla wszystkich są przewidziane nagrody?',
                odpowiedz:
                    'Nagrody są zwykle przewidzane dla zwycięzców. Czasami organizator wykonuje losowania podczas zawodów. Też często jest przygotowany pakiet startowy dla każdego zawodnika, co jest wyszczególnione w informacjach dodatkowych danych zawodów.',
            },
            {
                pytanie: '17. Jakie czasy trzeba osiągać, aby awansować dalej?',
                odpowiedz:
                    'Wszystko zależy od osób, które wezmą udział w zawodach. Liczba przechodzących jest określona w harmonogramie, a czasy przechodzące do dalszych rund są ciężkie do określenia. Można korzystąc z Psych Sheet dostępnego na WCA w danych zawodach, gdy organizator zaimportuje rejestracje.',
            },
            {
                pytanie: '18. Jak wygląda proces startu w zawodach?',
                odpowiedz:
                    'Aby wziąć udział w zawodach należy uprzednio się zarejestrować i opłacić udział. W pierwszy dzień zawodów należy stawić się w czasie rejestracji, aby odebrać swój identyfikator i ewentualnie pakiet startowy. Jeśli jest się nowicjuszem należy stawić się na początek trwania rejestracji zawodników pierwszego dnia, by zdążyć na szkolenie dla nowicjuszy. Aby ułożyć w danej rundzie konkurencji, należy kostkę odłożyć na kartę startową na stole mieszaczy, a następnie udać się do poczekalni lub na stanowisko startowe (w zależności od trybu zawodów). Następnie biegacze i sędziowie będą informowali, co zrobić dalej.',
            },
            {
                pytanie: '19. Kiedy odbędą się zawody w takim i takim mieście?',
                odpowiedz:
                    'Wszystkie planowane zawody w danych miastach są ogłaszane na podstronie ZAWODY. Pytanie kiedy zawody odbędą się jakimś mieście nie sprawi organizacji zawodów w tym miejscu. Jeśli ktoś chce zorganizować zawody w swoim mieście z naszą pomocą, prosimy skorzystać z zakładki kontakt.',
            },
            {
                pytanie: '20. Jak można zorganizować z nami zawody?',
                odpowiedz:
                    'Jeśli ktoś chce zorganizować zawody z naszą pomocą, prosimy skorzystać z zakładki kontakt.',
            },
            {
                pytanie: '21. Co warto zabrać na zawody?',
                odpowiedz:
                    'Na zawody trzeba zabrać ze sobą przede wszystkim kostki. Trzeba też ze sobą zabrać potrzebny sprzęt do startu w konkurencji jak np. opaska do układania bez patrzenia. Poza tym, wszystkie rzeczy potrzebne do startu jak karty startowe, pokrywki, długopisy, timery itd. zapewnia organizator.',
            },
            {
                pytanie: '22. Kiedy dostanę WCA ID?',
                odpowiedz:
                    'Identyfikator tworzy się podczas zakładania konta na WCA lub po wystartowaniu w pierwszych zawodach (do dwóch tygodni od pierwszych zawodów).',
            },
            {
                pytanie: '23. Co to jest scenariusz startów?',
                odpowiedz:
                    'Scenariusz startów służy do określenia grup zawodnika podczas zawodów. Pierwsze rundy są zawsze podzielone na grupy, a w scenariuszu zawodnik może się dowiedzieć w jakich grupach startuje, miesza, sędziuje czy biega z kostkami.',
            },
            {
                pytanie: '24. Co oznaczają liczby w scenariuszu?',
                odpowiedz:
                    'Liczby w tabeli oznaczają numery grup startowych, na które zostały podzielone dane konkurencje. Scenariusz określa uczestnikowi Jego rolę w danej grupie. ',
            },
            {
                pytanie: '25. Skąd mam wiedzieć kiedy dokładnie startuję i w jakiej grupie?',
                odpowiedz:
                    'Za wszystko jest odpowiedzialny scenariusz startów dostępny przed zawodami w zakładce MOJE KONTO. Scenariusz jest również dostępny podczas zawodów z tyłu identyfikatora zawodnika. Dokładny start określają liczby w scenariuszu, które oznaczają grupy zawodnika.',
            },
            {
                pytanie: '26. Czy będą gdzieś dostępne zdjęcia z zawodów?',
                odpowiedz:
                    'Zdjęcia z zawodów będą dostępne po zawodach w zakładce GALERIA na stronie głównej. Termin pojawienia się zdjęć z zawodów nie jest określony i może zająć kilka dni w porywach do kilku tygodni.',
            },
            {
                pytanie: '27. Mam źle wpisany wynik - co zrobić?',
                odpowiedz:
                    'W przypadku źle zapisanego wyniku należy zgłosić się do delegata zawodów albo na zawodach, a po zawodach za pośrednictwem maila umieszczonego pod kliknięciem na imię i nazwisko delegata wypisanego w zakładce INFORMACJE lub korzystając z emaila podanego na stronie WCA.',
            },
            {
                pytanie: '28. Co to znaczy comp, scr, run, judge przy scenariuszu?',
                odpowiedz:
                    'Comp oznacza Competing, czyli układanie. Jest to kolumna, w której jest przydzielony numer grupy startowej zawodnika w danej konkurencji. Scr oznacza Scrambling, czyli mieszanie. Jest to kolumna, w której jest przydzielony numer mieszania grupy w danej konkurencji. Run oznacza Running, czyli bieganie. Jest to kolumna, w której jest przydzielony numer biegania grupy w danej konkurencji. Judge oznacza sędziowanie. Jest to kolumna, w której jest przydzielony numer sędziowania grupy w danej konkurencji.',
            },
            {
                pytanie: '29. Dlaczego nie ma takiej i takiej konkurencji na zawodach?',
                odpowiedz:
                    'Konkurencje ustala organizator zawodów według swojej preferencji, a wiadomości czy emaile o podniesienie limitów nie spowodują zmiany konkurencji.',
            },
            {
                pytanie: '30. Czy planujecie dodać taką i taką konkurencję na zawodach?',
                odpowiedz:
                    'Konkurencje podane podczas ogłoszenia zawodów są dokładnie tymi planowanymi i organizator nie zakłada zmiany konkurencji po uprzednim ich ustaleniu. wiadomości czy emaile o podniesienie limitów nie spowodują zmiany konkurencji.',
            },
            {
                pytanie: '31. Czy możecie podnieść limity na zawodach?',
                odpowiedz:
                    'Limity są ustanowione z góry przez organizatora, a wiadomości czy emaile o podniesienie limitów nie spowodują zmiany.',
            },
            {
                pytanie: '32. Dlaczego ta i ta konkurencja jest tak rzadko na zawodach?',
                odpowiedz:
                    'Konkurencje ustala organizator zawodów, a wiadomości czy emaile o podniesienie limitów nie spowodują zmiany konkurencji.',
            },
            {
                pytanie: '33. Jak jest liczona klasyfikacja cube4fun League?',
                odpowiedz:
                    '<table><tr><td>Rodzaj bonusu:</td><td>Punkty:</td></tr><tr><td><br/></td><td><br/></td></tr><tr><td>PB (rekord życiowy)</td><td>100</td></tr><tr><td>Rekord Polski</td><td>250</td></tr><tr><td>Rekord Europy (lub kontynentu)</td><td>500</td></tr><tr><td>Rekord Świata</td><td>1000</td></tr><tr><td>Pierwsze zawody</td><td>200</td></tr><tr><td>Zawody online</td><td>Punkty x3</td></tr><tr><td><br/></td><td><br/></td></tr><tr><td>Miejsce:</td><td>Punkty:</td></tr><tr><td> 1</td><td>    500</td></tr><tr><td> 2</td><td>    440</td></tr><tr><td> 3</td><td>    400</td></tr><tr><td> 4</td><td>    366</td></tr><tr><td> 5</td><td>    339</td></tr><tr><td> 6</td><td>    317</td></tr><tr><td> 7</td><td>    299</td></tr><tr><td> 8</td><td>    284</td></tr><tr><td> 9</td><td>    271</td></tr><tr><td> 10</td><td>    260</td></tr><tr><td> 11</td><td>    250</td></tr><tr><td> 12</td><td>    241</td></tr><tr><td> 13</td><td>    233</td></tr><tr><td> 14</td><td>    225</td></tr><tr><td> 15</td><td>    218</td></tr><tr><td> 16</td><td>    211</td></tr><tr><td> 17</td><td>    204</td></tr><tr><td> 18</td><td>    198</td></tr><tr><td> 19</td><td>    192</td></tr><tr><td> 20</td><td>    186</td></tr><tr><td> 21</td><td>    180</td></tr><tr><td> 22</td><td>    175</td></tr><tr><td> 23</td><td>    170</td></tr><tr><td> 24</td><td>    165</td></tr><tr><td> 25</td><td>    160</td></tr><tr><td> 26</td><td>    155</td></tr><tr><td> 27</td><td>    151</td></tr><tr><td> 28</td><td>    147</td></tr><tr><td> 29</td><td>    143</td></tr><tr><td> 30</td><td>    139</td></tr><tr><td> 31</td><td>    135</td></tr><tr><td> 32</td><td>    131</td></tr><tr><td> 33</td><td>    127</td></tr><tr><td> 34</td><td>    123</td></tr><tr><td> 35</td><td>    119</td></tr><tr><td> 36</td><td>    115</td></tr><tr><td> 37</td><td>    112</td></tr><tr><td> 38</td><td>    109</td></tr><tr><td> 39</td><td>    106</td></tr><tr><td> 40</td><td>    103</td></tr><tr><td> 41</td><td>    100</td></tr><tr><td> 42</td><td>    97</td></tr><tr><td> 43</td><td>    94</td></tr><tr><td> 44</td><td>    91</td></tr><tr><td> 45</td><td>    88</td></tr><tr><td> 46</td><td>    85</td></tr><tr><td> 47</td><td>    82</td></tr><tr><td> 48</td><td>    79</td></tr><tr><td> 49</td><td>    76</td></tr><tr><td> 50</td><td>    73</td></tr><tr><td> 51</td><td>    70</td></tr><tr><td> 52</td><td>    68</td></tr><tr><td> 53</td><td>    66</td></tr><tr><td> 54</td><td>    64</td></tr><tr><td> 55</td><td>    62</td></tr><tr><td> 56</td><td>    60</td></tr><tr><td> 57</td><td>    58</td></tr><tr><td> 58</td><td>    56</td></tr><tr><td> 59</td><td>    54</td></tr><tr><td> 60</td><td>    52</td></tr><tr><td> 61</td><td>    50</td></tr><tr><td> 62</td><td>    48</td></tr><tr><td> 63</td><td>    46</td></tr><tr><td> 64</td><td>    44</td></tr><tr><td> 65</td><td>    42</td></tr><tr><td> 66</td><td>    40</td></tr><tr><td> 67</td><td>    38</td></tr><tr><td> 68</td><td>    36</td></tr><tr><td> 69</td><td>    34</td></tr><tr><td> 70</td><td>    32</td></tr><tr><td> 71</td><td>    30</td></tr><tr><td> 72</td><td>    29</td></tr><tr><td> 73</td><td>    28</td></tr><tr><td> 74</td><td>    27</td></tr><tr><td> 75</td><td>    26</td></tr><tr><td> 76</td><td>    25</td></tr><tr><td> 77</td><td>    24</td></tr><tr><td> 78</td><td>    23</td></tr><tr><td> 79</td><td>    22</td></tr><tr><td> 80</td><td>    21</td></tr><tr><td> 81</td><td>    20</td></tr><tr><td> 82</td><td>    19</td></tr><tr><td> 83</td><td>    18</td></tr><tr><td> 84</td><td>    17</td></tr><tr><td> 85</td><td>    16</td></tr><tr><td> 86</td><td>    15</td></tr><tr><td> 87</td><td>    14</td></tr><tr><td> 88</td><td>    13</td></tr><tr><td> 89</td><td>    12</td></tr><tr><td> 90</td><td>    11</td></tr><tr><td> 91</td><td>    10</td></tr><tr><td> 92</td><td>    9</td></tr><tr><td> 93</td><td>    8</td></tr><tr><td> 94</td><td>    7</td></tr><tr><td> 95</td><td>    6</td></tr><tr><td> 96</td><td>    5</td></tr><tr><td> 97</td><td>    4</td></tr><tr><td> 98</td><td>    3</td></tr><tr><td> 99</td><td>    2</td></tr><tr><td> 100</td><td>    1</td></tr></table>',
            },
            {
                pytanie: '34. Gdzie muszę oddać kostkę, aby układać?',
                odpowiedz:
                    'Kostkę należy umieścić na swojej karcie startowej, która leży na stole mieszaczy podczas grupy określonej w scenariuszu.',
            },
            {
                pytanie: '35. Jak mogę opłacić wpisowe dla gości?',
                odpowiedz: 'Wpisowe dla gości jest uiszczane na miejscu zawodów.',
            },
        ],
    },
    {
        categoryName: 'TRUDNE SŁÓWKA',
        questions: [
            {
                pytanie: '1. Cut-off',
                odpowiedz:
                    "Jest to jeden z typów limitów czasowych. W przypadku konkurencji ze średnią z pięciu ułożeń należy w pierwszym lub w drugim ułożeniu zrobić wynik lepszy niż cut-off. W przypadku konkurencji ze średnią z trzech ułożeń, limit cut-off należy spełnić w pierwszym ułożeniu. UWAGA - wynik dokładnie równy cut-off'owi nie jest lepszym wynikiem niż ten limit i na podstawie tego wyniku zawodnik nadal nie jest upoważniony do kręcenia pełnej średniej.",
            },
            {
                pytanie: '2. Best',
                odpowiedz: 'Jest to najlepsze ułożenie w danej rundzie.',
            },
            {
                pytanie: '3. Worst',
                odpowiedz: 'Jest to najgorsze ułożenie w danej rundzie.',
            },
            {
                pytanie: '4. Avg 5',
                odpowiedz:
                    'Rozwinięciem tego skrótu jest Average of 5, czyli średnia z pięciu ułożeń. Średnią z pięciu ułożeń liczymy na zawodach z trzech środkowych wyników, czyli odrzucamy najlepszy i najgorszy czas w średniej.',
            },
            {
                pytanie: '5. Best of 2 / Avg 5',
                odpowiedz:
                    'Jest to rodzaj formatu określanego dla rund kombinowanych, czyli rund w których występuje limit cut-off. W taki sposób oznaczamy, że zawodnik będzie klasyfikowany na podstawie najlepszego ułożenia z dwóch wykręconych lub na podstawie średniej z pięciu ułożeń jeśli zawodnik zmieścił się w limicie cut-off.',
            },
            {
                pytanie: '6. Best of 3',
                odpowiedz:
                    'Jest to określenie formatu klasyfikowania zawodników na podstawie najlepszego ułożenia spośród trzech wykonanych ułożeń.',
            },
            {
                pytanie: '7. Bo 1 / Mo 3',
                odpowiedz:
                    'Jest to rodzaj formatu określanego dla rund kombinowanych, czyli rund w których występuje limit cut-off. W taki sposób oznaczamy, że zawodnik będzie klasyfikowany na podstawie jednego ułożenia lub na podstawie średniej z trzech ułożeń jeśli zawodnik zmieścił się w limicie cut-off.',
            },
            {
                pytanie: '8. Limit czasu',
                odpowiedz:
                    'Jest to limit czasu określony przez organizatora zawodów - gdy zawodnik ten czas przekroczy, jego ułożenie zostaje zdyskwalifikowane.',
            },
            {
                pytanie: '9. Delegat zawodów',
                odpowiedz:
                    'Jest to główny sędzia na oficjalnych zawodach, którego decyzja jest ostateczna w większości kwestii spornych.',
            },
            {
                pytanie: '10. WCA',
                odpowiedz: 'Światowe Stowarzyszenie Speedcubingu - World Cube Association',
            },
            {
                pytanie: '11. Display',
                odpowiedz:
                    'Jest to ekran podłączony do timera pokazujacy czas, jaki zawodnik ma w danym momencie.',
            },
            {
                pytanie: '12. X min kum. / limit kumulowany',
                odpowiedz:
                    'Jest to odpowiednik DNF limitu w konkurencjach polegających na układaniu bez patrzenia. Gdy suma czasów wszystkich ułożeń zawodnika w danej rundzie przewyższa limit kumulowany, ostatnie ułożenie w tej rundzie zostaje zdyskwalifikowane.',
            },
            {
                pytanie: '13. Główna konkurencja',
                odpowiedz:
                    'Konkurencja, której medaliści są zwykle wyróżnieni jako medaliści całych zawodów. Najczęściej konkurencją główną jest 3x3x3.',
            },
            {
                pytanie: '14. Mieszacz / scrambler',
                odpowiedz:
                    'Osoba, która miesza kostki podczas danej rundy zawodów. Mieszaczem może zostać każdy chętny uczestnik zawodów, jeśli potrafi to robić. Mieszanie jest również obowiązkowe dla zawodników, którzy posiadają już WCA ID jeśli mają takie zadanie przydzielone w swoim scenariuszu.',
            },
            {
                pytanie: '15. Zawody oficjalne',
                odpowiedz:
                    'Jest to turniej nadzorowany przez Delegata WCA, z którego wyniki trafiają do bazy wyników organizacji WCA.',
            },
            {
                pytanie: '16. Poczekalnia',
                odpowiedz:
                    'Jest to miejsce, w którym przebywają zawodnicy pomiędzy swoimi ułożeniami w obrębie jednej rundy.',
            },
            {
                pytanie: '17. PSS',
                odpowiedz: 'Polskie Stowarzyszenie Speedcubingu',
            },
            {
                pytanie: '18. Regulamin WCA',
                odpowiedz:
                    'Jest to spis zasad tworzony przez organizację WCA, na podstawie których przeprowadzana jest większość zawodów speedcubingowych.',
            },
            {
                pytanie: '19. Runner / biegacz',
                odpowiedz:
                    'Osoba, która dostarcza kostki ze stanowiska mieszaczy do sędziego. Jeśli na zawodach występuje poczekalnia to dodatkowym obowiązkiem runnera jest wywołanie zawodnika z tego miejsca. Runnerem może zostać każdy chętny uczestnik zawodów lub nawet i osoba towarzysząca, jeśli przejdzie szkolenie delegata. Bieganie jest również obowiązkowe dla zawodników, którzy posiadają już WCA ID jeśli mają takie zadanie przydzielone w swoim scenariuszu.',
            },
            {
                pytanie: '20. Judge / sędzia',
                odpowiedz:
                    'Osoba, która sędziuje ułożenie zawodników podczas danej rundy pilnując zasad panujących wobec startu. Sędzią może zostać każdy chętny uczestnik zawodów lub nawet i osoba towarzysząca, jeśli przejdzie szkolenie delegata. Sędziowanie jest również obowiązkowe dla zawodników, którzy posiadają już WCA ID jeśli mają takie zadanie przydzielone w swoim scenariuszu.',
            },
            {
                pytanie: '21. Stanowisko startowe',
                odpowiedz:
                    'Jest to stół wyposażony w timer, matę i display, przy którym zawodnik wykonuje oficjalne ułożenia. Zwykle stanowiska startowe są oklejone plakatami, które przesłaniają nogi zawodnika podczas układania dla lepszego efektu profesjonalizmu wydarzenia.',
            },
            {
                pytanie: '22. Stanowisko rejestracji / Stanowisko rejestratora wyników',
                odpowiedz:
                    'Stanowiskiem rejestratorów lub rejestracją określa się miejsce, w którym są wpisywane wyniki przez rejestratora wyników. To właśnie na tym stole obok rejestratora znajduje się miejsce oddawania kart startowych, które są już kompletne. Stanowisko rejestratorów jest bardzo często połączone ze stanowiskiem organizatora i delegatów lub znajduje się w pobliżu.',
            },
            {
                pytanie: '23. Stanowisko mieszaczy / Mieszalnia',
                odpowiedz:
                    'Jest to miejsce, w którym są mieszane kostki, które następnie trafiają do stanowisk startowych. Zawsze na stole mieszaczy znajduje się karta startowa, na którą należy odłożyć kostkę, aby wziąć udział w danej grupie rundy danej konkurencji.',
            },
            {
                pytanie: '24. Timer / stack',
                odpowiedz:
                    'Czasomierz, który rozpoczyna i kończy mierzyć czas, kiedy zawodnik położy na panelach dotykowych obie dłonie.',
            },
            {
                pytanie: '25. Stoper',
                odpowiedz:
                    'Jest to czasomierz sportowy, który służy do odliczania czasu preinspekcji. Zwykle lwey przycisk służy do startu i zatrzymania, a prawy przycisk do resetu zmierzonego czasu.',
            },
            {
                pytanie: '26. Mata',
                odpowiedz:
                    'Jest to mata przystosowana między innymi do speedcubingu, na której zawodnicy odbywają swoje oficjalne ułożenia.',
            },
            {
                pytanie: '27. Zawody online',
                odpowiedz:
                    'Jest to turniej przeprowadzony w formie zdalnej (weryfikacja odbywa się na podstawie nagrań ułożeń). Zawody online nie są zaowdami oficjalnymi.',
            },
            {
                pytanie: "28. Zawody side'owe / side'y",
                odpowiedz:
                    'Są to zawody "boczne" - takie, w których zawodnicy rywalizują wyłącznie w konkurencjach, które na zwykłych zawodach organizowane są stosunkowo rzadko.',
            },
            {
                pytanie: '29. Cube4fun League',
                odpowiedz:
                    'Jest to liga firmy cube4fun, która charakteryzuje się utrzymaniem pewnego poziomu organizacji. Po zawodach z danej imprezy jest liczona klasyfikacja, która również jest sumowana do klasyfikacji ogólnej, na podstawie której jest wyłaniany zwycięzca ligii na dany rok.',
            },
            {
                pytanie: '30. Mo 3 / Mean of 3',
                odpowiedz:
                    'Jest to średnia z 3 ułożeń - w formacie mo ("mean of") liczone są wszystkie czasy - nawet najgorszy i najlepszy z nich.',
            },
            {
                pytanie: '31. Karta startowa',
                odpowiedz:
                    'Jest to kartka A6, która znajduje się na stole mieszaczy, na którą trzeba odłożyć kostkę, by móc ułożyć w danej grupie rundy danej konkurencji.',
            },
            {
                pytanie: '32. Stanowisko organizatorów',
                odpowiedz:
                    'Jest to stanowisko, przy którym można rozkłada się organizator ze swoimi rzeczami. Również w pobliżu często znajduje się zapasowy sprzęt potrzebny do przeprowadzenia zawodów. Zwykle stół organizatorów jest połączony ze stołem rejestratorów i stołem delegatów lub znajduje się w pobliżu.',
            },
            {
                pytanie: '33. Stanowisko delegatów',
                odpowiedz:
                    'Jest to stanowisko, przy którym można spotkać delegatów oraz delegaci trzymają swój sprzęt niezbędny do przeprowadzenia imprezy. Zwykle stół delegatów jest połączony ze stołem rejestratorów oraz stołem organizatorów lub znajduje się w pobliżu.',
            },
        ],
    },
    {
        categoryName: 'PROCES REJESTRACJI KONTA',
        questions: [
            {
                pytanie: '1. Czy muszę podawać avatar?',
                odpowiedz: 'Nie. Avatar nie jest obowiązkowy.',
            },
            {
                pytanie: '2. Dlaczego mój avatar został usunięty?',
                odpowiedz:
                    'Avatar mógł zostać usunięty ze względu na niespełnione wymogi zaakceptowane podczas przesyłania avataru.',
            },
            {
                pytanie: '3. Co to jest WCA ID?',
                odpowiedz:
                    'Jest to identyfikator WCA przydzielony zawodnikowi. Identyfikator tworzy się podczas zakładania konta na WCA lub po wystartowaniu w pierwszych zawodach (do dwóch tygodni od pierwszych zawodów).',
            },
            {
                pytanie: '4. Czy numer telefonu jest obowiązkowy?',
                odpowiedz:
                    'Tak - numer telefonu jest obowiązkowy, aby organizator lub delegat mógł się skontaktować z zawodnikiem w dowolnej chwili.',
            },
            {
                pytanie: '5. Dlaczego muszę podawać datę urodzenia?',
                odpowiedz:
                    'Tak - data urodzenia jest wymagana przez WCA, aby móc wystartować w zawodach.',
            },
            {
                pytanie: '6. Czy dane mogą być inne niż w rzeczywistości?',
                odpowiedz:
                    'Nie - dane muszą być dokładnie jak dowodzie osobistym lub innym prawnym dokumencie.',
            },
            {
                pytanie: '7. Gdy chcę dodać avatar występuje błąd - dlaczego?',
                odpowiedz:
                    'Akceptowane rozszerzenia to .jpg i .png. Maksymalna wielkość pliku to 10MB. W przypadku spełnienia tych dwóch wymogów i dalszych problemów, prosimy skorzystać z zakładki kontakt i dokładnie opisać swój problem. Aby szybciej uzyskać pomoc, warto w wiadomości email dołączyć swój numer telefonu.',
            },
            {
                pytanie: '8. Nie mogę się zarejestrować, jest jakiś błąd - co mam zrobić?',
                odpowiedz:
                    'W takim przypadku należy skorzystać z zakładki kontakt dokładnie opisując swój problem i załączając zrzuty ekranu. W wiadomości email warto dołączyć swój numer telefonu.',
            },
        ],
    },
    {
        categoryName: 'PROCES REJESTRACJI NA ZAWODY',
        questions: [
            {
                pytanie: '1. Jak można się zarejestrować?',
                odpowiedz:
                    'Aby się zarejestrować na zawody należy wybrać dane zawody i przejść do zakładki REJESTRACJA.',
            },
            {
                pytanie:
                    '2. Nie zdążyłem się zarejestrować - czy mogę jeszcze wystartować w zawodach?',
                odpowiedz:
                    'Nie - w przypadku oficjalnych zawodów stosujemy się do regulaminu WCA. W przypadku zawodów online lub nieoficjalnych można skorzystać z zakładki kontakt i zadzwonić na podany numer - może się okazać, że taka możliwość jeszcze istnieje.',
            },
            {
                pytanie: '3. Gdzie mogę zmienić konkurencje, w których chcę startować?',
                odpowiedz:
                    'Zmienić swoje konkurencje na dane zawody można na podstronie MOJE KONTO w zakładce MOJE ZAWODY. Zmieniać konkurencje można tylko i wyłącznie w zatwierdzonej rejestracji, czyli w rejestracji kompletnej.',
            },
            {
                pytanie: '4. Czy żeby się zarejestrować na zawody muszę posiadać założone konto?',
                odpowiedz:
                    'Tak - aby móc wziąć udział w zawodach i się zarejestrować należy uprzednio założyć konto.',
            },
            {
                pytanie:
                    '5. Rejestruję na zawody dziecko - czy muszę podać swoje dane czy dziecka?',
                odpowiedz: 'Rejestrując dziecko należy podać dane zawodnika, czyli dane dziecka.',
            },
            {
                pytanie: '6. Gdzie mogę zrezygnować z zawodów?',
                odpowiedz:
                    'Przycisk do rezygnacji z zawodów znajduje się na podstronie MOJE KONTO w zakładce MOJE ZAWODY. Aby zrezygnować z zawodów należy uprzednio się zalogować.',
            },
            {
                pytanie: '7. Czy zostanie mi zwrócone wpisowe, jeśli nie przyjechałem na zawody?',
                odpowiedz:
                    'Wpisowe zostaje zwracane tylko i wyłącznie w przypadku rezygnacji poprzez przycisk ZREZYGNUJ na podstronie MOJE KONTO w zakładce MOJE ZAWODY, gdy ostateczny termin zwracania płatności nie zostanie przekroczony. W przeciwnym wypadku wpisowe w żadnym stopniu nie jest zwracane.',
            },
            {
                pytanie:
                    '8. Czy jeśli nie byłem na zawodach to organizator może wysłać mi mój giftpack?',
                odpowiedz:
                    'Nie - organizator wyklucza możliwość wysłania giftpacka. Giftpacki są możliwe do odbioru przez zawodnika lub osobę pośredniczącą jedynie na miejscu zawodów podczas trwania turnieju.',
            },
            {
                pytanie: '9. Jak zrezygnować z zawodów, aby odzyskać opłacone wcześniej wpisowe?',
                odpowiedz:
                    'Należy to zrobić poprzez przycisk do rezygnacji z zawodów, który znajduje się na podstronie MOJE KONTO w zakładce MOJE ZAWODY. Aby zrezygnować z zawodów z odzyskaniem kwoty wpisowego należy uprzednio się zalogować i upewnić się, że ostateczny termin zwracania płatności nie został przekroczony.',
            },
            {
                pytanie: '10. Jak opłacić udział w zawodach?',
                odpowiedz:
                    'Płatność za udział w zawodach odbywa się poprzez kliknięcie przycisku OPŁAĆ zaraz po zarejestrowaniu się lub poprzez ten sam przycisk znajdujący się na podstronie MOJE KONTO w zakładce MOJE ZAWODY. Pośrednikiem przy płatności jest serwis Przelewy24.pl',
            },
            {
                pytanie: '11. Dlaczego mam status rejestracji OCZEKUJĄCY?',
                odpowiedz:
                    'Status rejestracji OCZEKUJĄCY oznacza, iż zawodnik zarejestrował się w terminie i w limicie zawodników, lecz nie dokończył swojej rejestracji poprzez opłacenie kwoty wpisowego.',
            },
            {
                pytanie: '12. Dlaczego mam status rejestracji ODRZUCONY?',
                odpowiedz:
                    'Status rejestracji ODRZUCONY pojawia się, gdy zawodnik zrezygnuje z zawodów lub nie opłaci swojego udziału w zawodach w czasie. Zawody ze statusem ODRZUCONY zostają usunięte z listy zawodów użytkownika, gdy minie data zawodów, których dotyczyła rejestracja.',
            },
            {
                pytanie: '13. Dlaczego mój nick wyświetla się na czerwono lub na niebiesko?',
                odpowiedz:
                    'Nowicjusze bez WCA ID są wyświetlani na czerwono, zaś osoby, które już były wcześniej na zawodach, są wyświetlane na niebiesko.',
            },
            {
                pytanie: '14. Nie mogę się zarejestrować - występuje błąd strony. Co mam zrobić?',
                odpowiedz:
                    'W przypadku problemów technicznych podczas rejestracji na zawody należy skorzystać z formularza kontaktowego w zakładce kontakt.',
            },
        ],
    },
];

export { faqQuestions };
